export default __webpack_public_path__ + "static/media/m3_element_red.0fc16923.png";